var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group row mt-4 select" },
    [
      _c(
        "div",
        {
          class: [
            _vm.isReadOnly || _vm.disabled ? "col-sm-5" : "col-lg-3",
            "col-12 col-form-label organisation-search"
          ]
        },
        [
          _c(
            "label",
            {
              staticClass: "d-inline",
              attrs: {
                for: _vm.id + "-filter" + _vm.index,
                id: _vm.title + _vm.index
              }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.$t(_vm.title)) + "\n      "),
              _vm.required
                ? _c("i", { staticClass: "fas fa-asterisk icon red" }, [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("Icon.Required")))
                    ])
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.instructionKey
            ? _c("tooltip-icon", {
                attrs: {
                  id: "labelTooltip" + _vm.index,
                  content: _vm.$t(_vm.instructionKey)
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isReadOnly && !_vm.disabled
        ? [
            _c(
              "span",
              {
                staticClass: "sr-only",
                attrs: { id: "filterDescription" + _vm.index }
              },
              [_vm._v(_vm._s(_vm.$t("OrganisationQuery.FilterDescription")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 col-sm-3 col-lg-2 pb-2 pb-sm-0" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filterValue,
                    expression: "filterValue"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  id: _vm.id + "-filter" + _vm.index,
                  maxlength: 50,
                  placeholder: _vm.$t(_vm.filterPlaceholder),
                  "aria-labelledby":
                    _vm.title + _vm.index + " filterDescription" + _vm.index,
                  "aria-describedby": "labelTooltip" + _vm.index
                },
                domProps: { value: _vm.filterValue },
                on: {
                  keyup: function($event) {
                    return _vm.filter()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filterValue = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-6 col-sm-2 col-lg-2 pb-2 pb-sm-0 col-form-label left",
                attrs: { "aria-atomic": "true", "aria-live": "polite" }
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(
                    _vm._s(_vm.$t("OrganisationQuery.ResultsAriaText")) + " "
                  )
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Total")) +
                    ": " +
                    _vm._s(_vm.filteredOptions.length) +
                    " " +
                    _vm._s(_vm.$t("Pcs")) +
                    "\n    "
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "sr-only",
          attrs: { id: "selectDescription" + _vm.index }
        },
        [_vm._v(_vm._s(_vm.$t("OrganisationQuery.SelectDescription")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.isReadOnly || _vm.disabled ? "col-sm-7" : "col-sm-7 col-lg-5",
            "col-xs-12"
          ]
        },
        [
          _c("ValidationProvider", {
            ref: "provider",
            attrs: { rules: { required: _vm.required }, slim: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  var failedRules = ref.failedRules
                  return [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedValue,
                            expression: "selectedValue"
                          }
                        ],
                        class: _vm.getValidationErrorClasses(failedRules),
                        attrs: {
                          name: _vm.id + _vm.index,
                          id: _vm.id + _vm.index,
                          disabled: _vm.isReadOnly || _vm.disabled,
                          "aria-required": _vm.required,
                          "aria-invalid": _vm.required && errors.length > 0,
                          "aria-labelledby":
                            _vm.title +
                            _vm.index +
                            " selectDescription" +
                            _vm.index
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedValue = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        !_vm.omitPlaceholder
                          ? _c(
                              "option",
                              {
                                attrs: { selected: "" },
                                domProps: { value: null }
                              },
                              [_vm._v(_vm._s(_vm.$t(_vm.selectPlaceholder)))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.filteredOptions, function(option) {
                          return _c(
                            "option",
                            {
                              attrs: {
                                title: _vm.doTruncation(option)
                                  ? option.name
                                  : null
                              },
                              domProps: { value: option }
                            },
                            [
                              _vm.doTruncation(option)
                                ? _c(
                                    "span",
                                    { attrs: { "aria-hidden": true } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            _vm.optionDisplayName(option),
                                            _vm.truncateLength
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { attrs: { "aria-hidden": false } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.optionDisplayName(option))
                                      )
                                    ]
                                  )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }